/* @flow */

import * as React from 'react';
import { useSelector } from 'react-redux';

import './SearchHistory.css';
import SearchHistoryTerm from './SearchHistoryTerm';

type SearchHistoryPropType = {
  +onSearchStringClick: (searchString: string) => void,
};

const SearchHistory = ({ onSearchStringClick }: SearchHistoryPropType): React.Node => {
  const searchHistory = useSelector<Array<string>>((state) => state.ui.searchHistory);

  if (searchHistory.length === 0) {
    // Only display non-empty history
    return null;
  }

  return (
    <div className='searchHistory'>
      {searchHistory.map((term) => (
        <SearchHistoryTerm key={term} onClick={onSearchStringClick} term={term} />
      ))}
    </div>
  );
};

export default SearchHistory;
